import React from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { useDataSetNewPage } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetNewPage';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { SaveIndicator } from 'apps/sigma2-ui/src/components/SaveIndicator';
import { MergeCategoryEnums } from 'libs/end-to-end/src/merge';
import { ResumeGradingOptions } from 'apps/sigma2-ui/src/data-wizard/components/ResumeGradingOptions';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';

export const DataSetNewPage = () => {
  const {
    organizationId,
    databaseId,
    databaseName,
    displayNameLabel,
    displayName,
    setDisplayName,
    type,
    setType,
    types,
    typeLabel,
    integrationType,
    setIntegrationType,
    integrationTypes,
    integrationTypeLabel,
    supplementalDataSetType,
    setSupplementalDataSetType,
    supplementalDataSetTypes,
    supplementalDataSetTypeLabel,
    submitButtonBehavior,
    submitButtonLabel,
    submitButtonDisabled,
    backButtonBehavior,
    backButtonLabel,
    backButtonDisabled,
    saveIndicatorStatus,
    mergeCategory,
    setMergeCategory,
    isResumeGradingEnabled,
    setIsResumeGradingEnabled,
    resumeGradingRubric,
    setResumeGradingRubric,
    openAiModel,
    setOpenAiModel,
  } = useDataSetNewPage();

  const mergeCategoriesOptions = MergeCategoryEnums.map((value) => {
    return { optionLabel: value, optionValue: value };
  });

  return (
    <AdminLayout currentPage={'DataSetNew'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Databases',
            to: `/organizations/${organizationId}/databases`,
          },
          {
            label: 'Edit Database',
            to: `/organizations/${organizationId}/databases/edit/${databaseId}`,
          },
          {
            label: 'Data Sets',
            to: `/organizations/${organizationId}/databases/${databaseId}/data-sets`,
          },
          {
            label: 'New Data Set',
            to: `/organizations/${organizationId}/databases/${databaseId}/data-sets/new`,
          },
        ]}
      />
      <Spacing size={'md'} direction={'vertical'}>
        <Paragraph>What kind of data set would you like to create?</Paragraph>
        <Paragraph>Database: {databaseName}</Paragraph>

        <div>
          <SimpleInput
            label={displayNameLabel}
            value={displayName}
            onChange={setDisplayName}
          />
        </div>

        <SelectBoxWithSearch
          type="single"
          list={types}
          label={typeLabel}
          selected={type}
          setSelected={setType}
        />

        {type === 'Integration' && (
          <SelectBoxWithSearch
            type="single"
            list={integrationTypes}
            label={integrationTypeLabel}
            selected={integrationType}
            setSelected={(v) => {
              setIntegrationType(v);
            }}
          />
        )}

        {integrationType === 'Merge' && (
          <>
            <Paragraph>
              Select the integration type for linked account.
            </Paragraph>
            <SelectBoxWithSearch
              type="single"
              list={mergeCategoriesOptions}
              label={'Linked Account Category'}
              selected={mergeCategory}
              setSelected={setMergeCategory}
            />
          </>
        )}

        {type === 'Supplemental' && (
          <SelectBoxWithSearch
            type="single"
            list={supplementalDataSetTypes}
            label={supplementalDataSetTypeLabel}
            selected={supplementalDataSetType}
            setSelected={(v) => {
              setSupplementalDataSetType(v);
            }}
          />
        )}

        <Spacing size="sm" direction="horizontal">
          <Button
            behavior={backButtonBehavior}
            text={backButtonLabel}
            disabled={backButtonDisabled}
          />

          <Button
            behavior={submitButtonBehavior}
            text={submitButtonLabel}
            disabled={submitButtonDisabled}
          />
        </Spacing>

        <SaveIndicator status={saveIndicatorStatus} />
      </Spacing>
    </AdminLayout>
  );
};
